// extracted by mini-css-extract-plugin
module.exports = {"cell":"table-cell_cell__NY_7S"};